import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import { Convenios } from "./interface/Convenios.interface";
import ConveniosEdit from "./convenios-edit";
import ConveniosList from "./convenios-list";

const ConveniosPage = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingConvenio, setEditingConvenio] = useState<Convenios | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (convenio: Convenios) => {
    setEditingConvenio(convenio);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir este convênio?")) {
      try {
        await api.delete(`/api/convenios/${id}`);
        toast({
          title: "Sucesso",
          description: "Convênio excluído com sucesso!",
        });
        // Recarrega a lista de convênios
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir convênio:", error);
        toast({
          title: "Erro",
          description: error.response?.data?.message || "Erro ao excluir convênio",
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    // Recarrega a lista de convênios
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingConvenio(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Convênios</h2>
            <p className="text-muted-foreground mt-1">
              Gerencie os convênios disponíveis no sistema
            </p>
          </div>
          <Button
            className="gap-2"
            onClick={() => {
              setEditingConvenio(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Novo Convênio
          </Button>
        </div>

        <ConveniosList
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <ConveniosEdit
          open={open}
          onOpenChange={setOpen}
          convenio={editingConvenio}
          onSuccess={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default ConveniosPage;

